import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isoWeek from "dayjs/plugin/isoWeek";
import { APPC } from ".";
dayjs.extend(utc);
dayjs.extend(isoWeek);

const schoolTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_REFERENCE_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_PEDAGOGICAL_REFERENCE_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_DIRECTOR,
    APPC.BE.User.USERTYPE.USERTYPE_STUDENT,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
];
const companyTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_SUPERVISOR,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_TUTOR,
    APPC.BE.User.USERTYPE.USERTYPE_COMPANY_DIRECTOR,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
];
const multiSelectTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_DIRECTOR,
    APPC.BE.User.USERTYPE.USERTYPE_COMPANY_DIRECTOR,
];
const userCreateTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
    APPC.BE.User.USERTYPE.USERTYPE_SUPER_ADMIN,
];
const schoolUserCreateTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_REFERENCE_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_PEDAGOGICAL_REFERENCE_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_DIRECTOR,
    APPC.BE.User.USERTYPE.USERTYPE_STUDENT,
];
const companyUserCreateTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_SUPERVISOR,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_TUTOR,
    APPC.BE.User.USERTYPE.USERTYPE_COMPANY_DIRECTOR,
];
const superAdminUserCreateTypes = [
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER,
    APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR,
    APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY,
    APPC.BE.User.USERTYPE.USERTYPE_SUPER_ADMIN,
];

export const isSchoolType = (type: string = ""): boolean => {
    return schoolTypes.includes(type);
};

export const isCompanyType = (type: string = ""): boolean => {
    return companyTypes.includes(type);
};

export const isSchoolCompanyMultiSelect = (type: string = ""): boolean => {
    return multiSelectTypes.includes(type);
};

export const isUserCreate = (type: string = ""): boolean => {
    return userCreateTypes.includes(type);
};

export const userCreateTypeAllow = (
    type: string = "",
    isSchool: boolean = false
): string[] => {
    if (
        type ===
            APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER ||
        (type === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY && isSchool)
    ) {
        return schoolUserCreateTypes;
    } else if (
        type === APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR ||
        (type === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY &&
            !isSchool)
    ) {
        return companyUserCreateTypes;
    } else if (type === APPC.BE.User.USERTYPE.USERTYPE_SUPER_ADMIN) {
        return superAdminUserCreateTypes;
    }
    return [];
};

export const userFilterTypeAllow = (
    type: string = "",
    isSchool: boolean = false
): string[] => {
    if (
        type ===
            APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR_TRAINER ||
        type === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_DIRECTOR ||
        (type === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY && isSchool)
    ) {
        return schoolUserCreateTypes;
    } else if (
        type === APPC.BE.User.USERTYPE.USERTYPE_INTERNSHIP_COORDINATOR ||
        type === APPC.BE.User.USERTYPE.USERTYPE_COMPANY_DIRECTOR ||
        (type === APPC.BE.User.USERTYPE.USERTYPE_SCHOOL_AND_COMPANY &&
            !isSchool)
    ) {
        return companyUserCreateTypes;
    } else if (type === APPC.BE.User.USERTYPE.USERTYPE_SUPER_ADMIN) {
        return superAdminUserCreateTypes;
    }
    return [];
};

export const toFixedUtcTime = (value: string | Date | null): Date | null => {
    if (!value) return null;

    const t = dayjs.utc(value);
    if (!t.isValid()) return null;

    const localDate = new Date(1970, 0, 1);
    localDate.setHours(t.hour(), t.minute(), t.second(), t.millisecond());
    return localDate;
};

export const isValidDate = (d: any): d is Date => {
    return d instanceof Date && !isNaN(d.getTime());
};

export const toFixedUtcDate = (value: string | Date | null): Date | null => {
    if (!value) return null;

    const date = dayjs.utc(value);
    if (!date.isValid()) return null;

    return new Date(
        date.year(),
        date.month(),
        date.date(),
        date.hour(),
        date.minute(),
        date.second(),
        date.millisecond()
    );
};

export const getDayJs = () => {
    return dayjs;
};

export const getWeekDayName = (dayNo: string | number): string => {
    const weekDayName = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
    return weekDayName[Number(dayNo)];
};

export const downloadFileHandler = (filePath: string, fileName: string) => {
    const link: HTMLAnchorElement = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const formatFileSize = (bytes: number): string => {
    if (bytes <= 0) return "0 KB";

    const KB = 1024;
    const MB = 1024 * 1024;

    if (bytes < MB) {
        return `${(bytes / KB).toFixed(2)} KB`;
    } else {
        return `${(bytes / MB).toFixed(2)} MB`;
    }
};

export const parseLinks = (text: string): string => {
    const urlRegex = /((https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?)/gi;
    return text.replace(urlRegex, (match) => {
        const url = match.startsWith("http") ? match : `https://${match}`;
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="app-parse-link">${match}</a>`;
    });
};

const userColors = {
    light: [
        "#fde2e4", // light pink
        "#fad2e1", // light rose
        "#e2ece9", // mint gray
        "#bee1e6", // pale aqua
        "#cddafd", // soft periwinkle
        "#d7e3fc", // soft blue
        "#e2f0cb", // pastel green
        "#ffe5d9", // peach
        "#ffd7ba", // light apricot
        "#fef9c7", // pale yellow
        "#e8e8e4", // stone gray
        "#f8edeb", // blush
        "#eaf4f4", // ice mint
        "#d3f8e2", // mint green
        "#e4c1f9", // lavender
        "#f1c0e8", // pink-purple
        "#c5e8f7", // sky blue
        "#fff1e6", // cream peach
        "#f9e2af", // soft gold
        "#ece5f0", // lilac gray
    ],
    dark: [
        "#f4a9b8", // darker pink
        "#f08bb4", // rose
        "#b8d8d2", // mint gray
        "#8ecae6", // aqua
        "#a0bdfc", // periwinkle
        "#9bbcf9", // blue
        "#c3e88d", // green
        "#ffb4a2", // peach
        "#f7a072", // apricot
        "#f4d35e", // yellow
        "#c9c9c9", // gray
        "#f5c2c7", // blush
        "#bde0e0", // ice mint
        "#95d5b2", // mint green
        "#c77dff", // lavender
        "#e599f7", // pink-purple
        "#90dbf4", // sky blue
        "#ffd6a5", // cream peach
        "#e9c46a", // gold
        "#cdb4db", // lilac
    ],
};
export const getRandomColors = (
    id: number,
    type: "light" | "dark" = "light"
): string => {
    const idStr = `${id}`;
    let hash = 0;
    for (let i = 0; i < idStr.length; i++) {
        hash = idStr.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % userColors[type].length;
    return userColors[type][index];
};

export const getInvertHexColor = (hex: string): string => {
    hex = hex.replace(/^#/, "");

    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((char) => char + char)
            .join("");
    }
    if (hex.length !== 6) {
        throw new Error("Invalid hex color");
    }

    const r = 255 - parseInt(hex.slice(0, 2), 16);
    const g = 255 - parseInt(hex.slice(2, 4), 16);
    const b = 255 - parseInt(hex.slice(4, 6), 16);

    return (
        "#" +
        [r, g, b]
            .map((v) => v.toString(16).padStart(2, "0"))
            .join("")
            .toUpperCase()
    );
};
